import React from "react";
import { Modal } from "react-bootstrap";
import "../../common.css";
import ResetPassword from "../forgotPassword/resetPassword";
import ForgotPassword from "../forgotPassword/forgotPassword";
import VerifyCode from "../forgotPassword/verifyCode";

const CommonModal = ({
  modelOpen,
  setModelOpen,
  headerContent,
  bodyContent,
  modalType,
  setModalType,
}) => {
  return (
    <Modal
      show={modelOpen}
      backdrop="static"
      keyboard={false}
      onHide={() => setModelOpen(false)}
      size="lg"
      className="loginMainModal"
      centered
    >
      <Modal.Header closeButton className="w-100 d-flex justify-content-center">
        <Modal.Title className="text-center w-100">{headerContent}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {modalType?.name === "forgotPassword" && (
          <ForgotPassword
            loginType={modalType?.type}
            onNext={(email) =>
              setModalType({
                name: "OtpVerification",
                type: modalType?.type,
                email,
              })
            }
          />
        )}

        {modalType?.name === "OtpVerification" && (
          <VerifyCode
            email={modalType?.email}
            type={modalType?.type}
            onNext={() =>
              setModalType({
                name: "resetPassword",
                type: modalType?.type,
                email: modalType?.email,
              })
            }
          />
        )}

        {modalType?.name === "resetPassword" && (
          <ResetPassword
            email={modalType?.email}
            type={modalType?.type}
            onClose={() => setModelOpen(false)}
          />
        )}
        {!modalType && bodyContent}
      </Modal.Body>
    </Modal>
  );
};

export default CommonModal;
